import React from "react";

import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import ReactHtmlParser from "html-react-parser";

import { AIQuestionText } from "../AI-question-text/AIQuestionText";

import "./AIAnswer.styles.scss";

interface AIAnswerTextProps {
  question?: string;
  answer: string;
  isTyping?: boolean;
}

export const AIAnswerText: React.FC<AIAnswerTextProps> = ({ question, answer, isTyping = false }) => {
  return (
    <Stack flexDirection="column" gap="15px">
      {question && <AIQuestionText question={question} />}
      <Typography
        sx={{
          backgroundColor: "#EDF1F980",
          borderRadius: "5px",
          padding: "5px",
          color: "#0A3142",
          minHeight: "20px",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          "& a": {
            color: "#0A3142",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline"
            }
          },
          "& .typing-cursor": {
            animation: "blink 1s step-end infinite",
            "@keyframes blink": {
              "from, to": { opacity: 1 },
              "50%": { opacity: 0 }
            }
          }
        }}
      >
        {ReactHtmlParser(answer)}
        {isTyping && <span className="typing-cursor">|</span>}
      </Typography>
    </Stack>
  );
};
